export const flightInfoPage = {
    additionalFuelInfo: ['Доп. сведения о топливе', 'Additional fuel info'],
    aircraftLandedOn: ['Дата и время посадки', 'Aircraft landed on'],
    aircraftTookOffOn: ['Дата и время взлёта', 'Aircraft took off on'],
    baggage: ['Багаж', 'Baggage'],
    before: ['Остаток на начало', 'Before'],
    blockFuel: ['Полная заправка', 'Block'],
    blockTime: ['Полетное ', 'Block time '],
    cabin: ['Ручная кладь', 'Cabin'],
    class: ['Класс', 'Class'],
    dutyTimeStartedOn: ['Начало смены', 'Duty time started on'],
    engineRunAfterLanding: ['Работа двигателя после посадки ', 'Engine run after landing '],
    engineRunBeforeTakeOff: ['Работа двигателей до взлёта ', 'Engine run before take off '],
    extra: ['Дополнительный', 'Extra'],
    extraCrew: ['Служ. пассажиры', 'Extra crew'],
    flightTime: ['Лётное ', 'Flight time '],
    ground: ['Расход на земле', 'Ground'],
    landing: ['Посадка', 'Landing'],
    landingInfo: ['Информация о посадке', 'Landing information'],
    landingTime: ['Время посадки', 'Landing time'],
    number: ['Количество', 'Number'],
    parkingTime: ['Время стоянки ', 'Parking time '],
    preFlightTime: ['Время предполётной подготовки ', 'Pre-flight time '],
    refueling: ['Заправка', 'Refueling'],
    restTime: ['Время отдыха ', 'Rest time '],
    shutdownOn: ['Остановка двигателей', 'Shutdown on'],
    startDutyTime: ['Начало смены', 'Start duty time'],
    startedLegOn: ['Время начала участка', 'Started leg on'],
    startEngine: ['Запуск двигателей', 'Start engine'],
    startEngineTime: ['Время запуска двигателя', 'Start engine time'],
    startLegTime: ['Начало участка', 'Start leg time'],
    startUpOn: ['Запуск двигателей', 'Start up on'],
    stopEngine: ['Остановка двигателя', 'Stop engine'],
    stopEngineTime: ['Время остановки двигателя', 'Stop engine time'],
    takeOff: ['Взлёт', 'Take off'],
    takeOffTime: ['Время взлёта', 'Take off time'],
    taxiOut: ['Расход на рулении', 'Taxi OUT'],
    totalInfo: ['Общие сведения', 'Total info'],
    tripFuel: ['Расход топлива', 'Trip fuel'],
    type: ['Тип', 'Type'],
    weight: ['Вес', 'Weight'],
};
